import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import { ToggleButton } from '../ToggleButton/ToggleButton';

type HtmlAttributes = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  muted?: boolean;
};

const MuteUnmuteButton: React.FC<
  WithTranslation & Pick<HtmlAttributes, Exclude<keyof HtmlAttributes, 'title'>>
> = ({ t, i18n, tReady, muted, ...props }) => (
  <ToggleButton
    primaryIcon={muted ? 'volume_mute' : 'volume_up'}
    secondaryIcon={muted ? 'volume_up' : 'volume_off'}
    title={t(muted ? 'unmute' : 'mute')}
    {...props}
  />
);

const Wrapped = withTranslation()(MuteUnmuteButton);
export { Wrapped as MuteUnmuteButton };
